import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { Eye, EyeOff } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@osmix/ui/button";
import { Input } from "@osmix/ui/input";
type PasswordInputProps = Omit<React.ComponentProps<typeof Input>, "type"> & {
  showLabel: string;
  hideLabel: string;
};
function PasswordInput(t0) {
  const $ = _c(23);
  let className;
  let disabled;
  let hideLabel;
  let props;
  let showLabel;
  if ($[0] !== t0) {
    ({
      className,
      showLabel,
      hideLabel,
      disabled,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = disabled;
    $[3] = hideLabel;
    $[4] = props;
    $[5] = showLabel;
  } else {
    className = $[1];
    disabled = $[2];
    hideLabel = $[3];
    props = $[4];
    showLabel = $[5];
  }
  const [visible, setVisible] = React.useState(false);
  const t1 = visible ? "text" : "password";
  let t2;
  if ($[6] !== className) {
    t2 = cn("pr-10", className);
    $[6] = className;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== disabled || $[9] !== props || $[10] !== t1 || $[11] !== t2) {
    t3 = <Input {...props} type={t1} disabled={disabled} className={t2} />;
    $[8] = disabled;
    $[9] = props;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setVisible(_temp);
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const t5 = visible ? hideLabel : showLabel;
  let t6;
  if ($[14] !== visible) {
    t6 = visible ? <EyeOff className="size-4" /> : <Eye className="size-4" />;
    $[14] = visible;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== disabled || $[17] !== t5 || $[18] !== t6) {
    t7 = <Button type="button" variant="ghost" size="icon-sm" className="absolute top-0.5 right-1" disabled={disabled} onClick={t4} aria-label={t5}>{t6}</Button>;
    $[16] = disabled;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t3 || $[21] !== t7) {
    t8 = <div className="relative">{t3}{t7}</div>;
    $[20] = t3;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
}
function _temp(value) {
  return !value;
}
export { PasswordInput };